module.exports = __webpack_public_path__ + "static/media/astro.4ad0704f.png";